import React from 'react';
import styled from 'styled-components';
import { PlacementSectionNumberBg } from 'utils/assets/images';

interface SectionLabelProps {
  sectionIndex?: number;
  title?: string;
  bgImage?: string;
  titleStyle?: React.CSSProperties;
  numberStyle?: React.CSSProperties;
  className: string;
}

const NumberContainer = styled.div<{ bgImage: string }>`
  height: 28px;
  width: 30px;
  font-size: 19px;
  border-radius: 50%;
  background-image: url(${(props) => props.bgImage});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffff00eb;
  text-shadow: -1px -2px 0px #1b1a1a,
               1px -1px 0px #1b1a1a,
              -1px  1px 0px #1b1a1a,
               1px  1px 0px #1b1a1a;
  font-style: italic;
  margin-left: 4px;
`;

const SectionTitle = styled.h2`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: bold;
  color: #004bad;
  margin-bottom: 0px;
`;

const SectionLabel: React.FC<SectionLabelProps> = ({
  sectionIndex = 0,
  title = 'Section',
  bgImage = PlacementSectionNumberBg,
  titleStyle,
  numberStyle,
  className
}) => {
  return (
    <SectionTitle style={titleStyle} className={className}>
      {title} <NumberContainer bgImage={bgImage} style={numberStyle}>{sectionIndex + 1}</NumberContainer>
    </SectionTitle>
  );
};

export default SectionLabel;